/* eslint-disable unicorn/filename-case -- a hook is not a component, and this package's rule assumes one */
import * as React from 'react';

const WIDE_QUERY = '(min-width: 64rem)';

function subscribe(onStoreChange: () => void) {
  const mql = window.matchMedia(WIDE_QUERY);
  mql.addEventListener('change', onStoreChange);
  return () => mql.removeEventListener('change', onStoreChange);
}

function getSnapshot() {
  return window.matchMedia(WIDE_QUERY).matches;
}

function getServerSnapshot() {
  return true;
}

/** True from Tailwind's `lg` breakpoint up. */
export function useIsWide() {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
